import Services from "../components/site/Services";

export default function ServicesPage() {
  return (
    <div className="pt-24">
      <Services />
    </div>
  );
}
